import {
  PRODUCTS_FETCH_FAILURE,
  PRODUCTS_FETCH_REQUEST,
  PRODUCTS_FETCH_SUCCESS,
  PRODUCT_FILTER_UPDATE_REQUEST,
  PRODUCT_FILTER_UPDATE_SUCCESS,
  PRODUCT_FILTER_UPDATE_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  products: [],      
  totalProducts: 0,  
  filters: {        
    title: '',
    barcode: '',
    supplier: '',
    category: '',
    status: '',
  },
  loading: false,     
  error: null,        
};

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };

    case PRODUCTS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.products,   
        totalProducts: action.payload.totalProducts,
      };

    case PRODUCTS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case PRODUCT_FILTER_UPDATE_REQUEST:
      return { ...state, loading: true, error: null };

    case PRODUCT_FILTER_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        filters: { ...state.filters, ...action.payload.filters },
        products: action.payload.products,                     
        totalProducts: action.payload.totalProducts,          
      };

    case PRODUCT_FILTER_UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default productsReducer;
